export const createFavData = (
  name,
  image,
  price,
  favorites_count,) => {
  return {
    name,
    image,
    price,
    favorites_count,
  };
}